<template>
	<div :class="buttonClass" @click="handleWhistleblower">
		<!-- PC版本 -->
		<template v-if="mode === 'pc'">
			<SvgIcons name="icon_voice" class="c-action-svg" />
			<span class="action-block-span">{{ $t('enterprise.whistleblower') }}</span>
		</template>

		<!-- 移动端版本 -->
		<template v-else>
			<SvgIcons name="icon_voice" class="mobile-action-svg" />
		</template>

		<CTeleport to="#app">
			<!-- PC端弹窗 -->
			<CDialogWhistleblower v-if="mode === 'pc'" :visible.sync="visibleWhistleblower" />
			<!-- 移动端弹窗 -->
			<c-mobile-whistleblower-popup v-if="mode === 'mobile'" :visible.sync="visibleWhistleblower" />
		</CTeleport>
	</div>
</template>

<script setup>
import { ref, inject } from 'vue';
import { useModuleDisplay } from '../hooks/useModuleDisplay.js';
import { debounce } from '@/utils/api';
import CDialogWhistleblower from '../CDialogWhistleblower.vue';
import CMobileWhistleblowerPopup from '@/components/mobile/c-mobile-whistleblower-popup.vue';

const mode = inject('mode');
const buttonClass = inject('roundButtonClass');

const { trackAction } = useModuleDisplay();

// 弹窗状态
const visibleWhistleblower = ref(false);

// 点击处理
const handleWhistleblower = debounce(
	() => {
		trackAction('whistleblower');
		visibleWhistleblower.value = true;
	},
	200,
	true
);
</script>
